import React from 'react';
import { Flex, Text, Image } from 'rebass';
import arrow from 'assets/icons/arrow.png';

interface SortingDropdownProps {
  text: string;
  mr?: string | number | string[] | number[];
}

const SortingDropdown: React.FC<SortingDropdownProps> = ({ text, mr }): JSX.Element => {
  return (
    <Flex alignItems="center" mr={mr}>
      <Text fontSize="18px" fontWeight={5}>
        {text}
      </Text>
      <Image src={arrow} ml={1} />
    </Flex>
  );
};

export default SortingDropdown;
